/*
 * @Author: 小周
 * @Date: 2023-09-06 16:50:12
 * @LastEditTime: 2024-08-02 15:54:14
 * @LastEditors: MrZHLF
 * @Description:
 */

import React, { useEffect, useState } from 'react'
import styles from './index.module.scss'
import { getMedalList } from '@/api/index'
import classNames from 'classnames'
import dayjs from 'dayjs'
import AppNavBar from '@/components/appNavBar'

const HomePage = () => {
  const [medal, setMedal] = useState([])

  useEffect(() => {
    getMedalList().then((res) => {
      if (res.results && res.results.length > 0) {
        setMedal(res.results)
      }
    })
  }, [])

  return (
    <div className={styles.home}>
      <AppNavBar msgType={5} />
      <div className={styles.wrapper}>
        <div className={styles.center}>
          <div className={styles.header}>
            <div className={styles.left}>奖牌榜</div>
            <div className={styles.right}>
              更新：{dayjs().format('MM-DD HH:mm')}
            </div>
          </div>
          {/* 列表 */}
          <div className={styles.rank}>
            <div className={styles.rank_header}>
              <div className={styles.rank_Ranking}>排名</div>
              <div className={styles.rank_Area}>国家/地区</div>
              <div className={styles.rank_Medal}>
                <div className={styles.medalImg}>
                  <img
                    src={require('./../../assets/images/metals.png')}
                    alt=""
                  />
                </div>
                <div className={styles.medalImg}>
                  <img
                    src={require('./../../assets/images/silver.png')}
                    alt=""
                  />
                </div>
                <div className={styles.medalImg}>
                  <img
                    src={require('./../../assets/images/copper.png')}
                    alt=""
                  />
                </div>
              </div>
              <div className={styles.rank_Sum}>总数</div>
            </div>
            <div className={styles.rankTable}>
              {medal &&
                medal.length > 0 &&
                medal.map((item, index) => {
                  const rankOther = styles.rank_Ranking
                  const ranks = [
                    styles.rank_one,
                    styles.rank_two,
                    styles.rank_three,
                  ]
                  const btnClass = classNames([
                    rankOther,
                    ...(index < 3 ? [ranks[index]] : []),
                  ])

                  return (
                    <div className={styles.list} key={index}>
                      <div className={btnClass}>{item.rankGold}</div>
                      <div className={styles.rank_Area}>
                        <img className={styles.icon} src={item.nocPic} alt="" />
                        <span className={styles.city}>
                          {item.organisationName}
                        </span>
                      </div>
                      <div className={styles.rank_Medal}>
                        <div className={styles.medalImg}>{item.medalsGold}</div>
                        <div className={styles.medalImg}>
                          {item.medalsSilver}
                        </div>
                        <div className={styles.medalImg}>
                          {item.medalsBronze}
                        </div>
                      </div>
                      <div className={styles.rank_Sum}>{item.medalsTotal}</div>
                    </div>
                  )
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default HomePage
